import { IEssayBody } from '../../../core/models/essay';
import { saveEssay } from '../../../core/queries/essays-queries/essayFunction';
import { useMutation } from '@tanstack/react-query';

export function useSaveEssay() {
  const { mutate, isPending, isError } = useMutation({
    mutationKey: ['saveEssay'], 
    mutationFn: (body: IEssayBody) => saveEssay(body),
    retry: false
  });

  return { mutate, isPending, isError };
}